
import Vue from "vue";

export default Vue.extend({
	props: {
		value: Boolean,
		title: {
			type: String,
			required: true
		},
		description: String,
		disabled: Boolean
	}
});
